/** Discounts apply to the hotel amount, never to selected optional bundles. */
export function getDiscountedPropertyCashPrice(price: number, discountAmount: number): number {
  return Math.max(price - discountAmount, 0)
}

export function getPropertyRateCashPrices(
  rate: Pick<App.EnrichedPropertyRate, 'totals' | 'luxPlusTotals'>,
  discountAmount: number,
  bundlesPrice: number,
) {
  const displayPrice = getDiscountedPropertyCashPrice(rate.totals.displayPrice, discountAmount)
  const displayMemberPrice = rate.luxPlusTotals?.displayPrice ? getDiscountedPropertyCashPrice(rate.luxPlusTotals.displayPrice, discountAmount) : undefined
  return {
    displayPrice,
    displayMemberPrice,
    displayedNonMemberPrice: displayPrice + bundlesPrice,
    displayedMemberPrice: displayMemberPrice === undefined ? undefined : displayMemberPrice + bundlesPrice,
  }
}
